export default __webpack_public_path__ + "static/media/Ellipse 17.b4b52da2.png";